module.exports = __webpack_public_path__ + "static/media/close-btn.7ce3985a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/close-btn.svg
// module id = 635
// module chunks = 0